import { gql } from "@apollo/client";

export const lectures = gql`
  query ($where: JSON, $sort: String) {
    lectures(where: $where, sort: $sort) {
      id
      label
      title
      slug
      views
      paid
      isPaid
      subscription
      blocked
      private
      verified {
        verified
      }
      practice {
        difficulty
        focus {
          id
          type
        }
        style {
          id
          type
        }
      }
      duration
      rating
      video {
        id
      }
      thumbnail {
        id
        name
        url
        formats
      }
      content_type
      profiles {
        slug
        nickname
        client {
          id
          name
          surname
        }
      }
      start_at
    }
    programs(where: $where, sort: $sort) {
      id
      label
      title
      slug
      views
      paid
      isPaid
      subscription
      blocked
      private
      verified {
        verified
      }
      practice {
        difficulty
        focus {
          id
          type
        }
        style {
          id
          type
        }
      }
      duration
      rating
      video {
        id
      }
      thumbnail {
        id
        name
        url
        formats
      }
      profiles {
        slug
        nickname
        client {
          name
          surname
        }
      }
    }
  }
`;
